export default "__VITE_ASSET__D4vZ2Jl8__"